module.exports = __webpack_public_path__ + "static/Vidhi__Mody_Full_Time_Resume-38e5c4c4a104dcc4776b4c39339feaf3.pdf";